import {useLocation} from 'react-router-dom';
import {ApprovalState, useApproveCallbackFromTrade} from '../../hooks/useApproveCallback'
import {ArrowWrapper, BottomGrouping, SwapCallbackError, Wrapper} from '../../components/swap/styleds'
import {AutoRow, RowBetween} from '../../components/Row'
import {ButtonConfirmed, ButtonError, ButtonLight, ButtonPrimary} from '../../components/ButtonLegacy'
import Card, {DarkCard, GreyCard} from '../../components/CardLegacy'
import {ChainId, CurrencyAmount, JSBI, Token, Trade} from '@sushiswap/sdk'
import Column, {AutoColumn} from '../../components/Column'
import {LinkStyledButton, TYPE} from '../../theme'
import React, {useCallback, useContext, useEffect, useMemo, useState, Component, useRef} from 'react'
import {computeTradePriceBreakdown, warningSeverity} from '../../utils/prices'
import {useAllTokens, useCurrency} from '../../hooks/Tokens'

import {
    useDefaultsFromURLSearch,
    useDerivedSwapInfo,
    useSwapActionHandlers,
    useSwapState
} from '../../state/swap/hooks'
import {useExpertModeManager, useUserSingleHopOnly, useUserSlippageTolerance} from '../../state/user/hooks'
import {useNetworkModalToggle, useToggleSettingsMenu, useWalletModalToggle} from '../../state/application/hooks'
import useWrapCallback, {WrapType} from '../../hooks/useWrapCallback'

import AddressInputPanel from '../../components/AddressInputPanel'
import AdvancedSwapDetailsDropdown from '../../components/swap/AdvancedSwapDetailsDropdown'
import {ArrowDown} from 'react-feather'
import {ClickableText} from '../Pool/styleds'
import ConfirmSwapModal from '../../components/swap/ConfirmSwapModal'
import CurrencyInputPanel from '../../components/CurrencyInputPanel'
import {Field} from '../../state/swap/actions'
import {Helmet} from 'react-helmet'
import {INITIAL_ALLOWED_SLIPPAGE} from '../../constants'
import {Link} from 'react-router-dom'
import Loader from '../../components/Loader'
import Lottie from 'lottie-react'
import PolygonLogo from '../../assets/images/matic-logo.png'
import ProgressSteps from '../../components/ProgressSteps'
import ReactGA from 'react-ga'
import SwapHeader from '../../components/ExchangeHeader'
import {SwapPoolTabs} from '../../components/NavigationTabs'
import {Text} from 'rebass'
import {ThemeContext} from 'styled-components'
import TokenWarningModal from '../../components/TokenWarningModal'
import TradePrice from '../../components/swap/TradePrice'
import UnsupportedCurrencyFooter from 'components/swap/UnsupportedCurrencyFooter'
import confirmPriceImpactWithoutFee from '../../components/swap/confirmPriceImpactWithoutFee'
import {isTradeBetter} from 'utils/trades'
import {maxAmountSpend} from '../../utils/maxAmountSpend'
import swapArrowsAnimationData from '../../assets/animation/swap-arrows.json'
import {t, Trans} from '@lingui/macro'
import {useActiveWeb3React} from '../../hooks/useActiveWeb3React'
import useENSAddress from '../../hooks/useENSAddress'
import {useIsTransactionUnsupported} from 'hooks/Trades'
import {useLingui} from '@lingui/react'
import {useSwapCallback} from '../../hooks/useSwapCallback'
import MisoBanner from '../../assets/images/miso-bannefr.jpg'
import MisoLogo from '../../assets/images/miso-logo.png'
import {useUser} from '../../hooks/useUser'
import {useCurrencyBalance} from "../../state/wallet/hooks";
import axios from "axios";
import {Chart, registerables} from "chart.js"
import {Line} from "react-chartjs-2"

Chart.register(...registerables)

interface QueryString {
    [key: string]: string;
}

export default function Dashboard() {
    const {i18n} = useLingui()
    const toggleNetworkModal = useNetworkModalToggle()

    const loadedUrlParams = useDefaultsFromURLSearch()

    const userdata = useUser()

    // token warning stuff
    const [loadedInputCurrency, loadedOutputCurrency] = [
        useCurrency(loadedUrlParams?.inputCurrencyId),
        useCurrency(loadedUrlParams?.outputCurrencyId)
    ]

    const [dismissTokenWarning, setDismissTokenWarning] = useState<boolean>(false)
    const urlLoadedTokens: Token[] = useMemo(
        () => [loadedInputCurrency, loadedOutputCurrency]?.filter((c): c is Token => c instanceof Token) ?? [],
        [loadedInputCurrency, loadedOutputCurrency]
    )
    const handleConfirmTokenWarning = useCallback(() => {
        setDismissTokenWarning(true)
    }, [])

    // dismiss warning if all imported tokens are in active lists
    const defaultTokens = useAllTokens()
    const importTokensNotInDefault =
        urlLoadedTokens &&
        urlLoadedTokens.filter((token: Token) => {
            return !Boolean(token.address in defaultTokens)
        })

    const {account, chainId} = useActiveWeb3React()
    const theme = useContext(ThemeContext)

    /** ##### **/

    const currencyETH = useCurrency(loadedUrlParams?.inputCurrencyId)

    const balanceETH = useCurrencyBalance(account ?? undefined, currencyETH ?? undefined)

    const [rate, setrate] = useState([])
    const [rate_max, setrate_max] = useState([])
    const [rate_min, setrate_min] = useState([])
    const [rate_per, setrate_per] = useState([])
    const [rate_chart_date, setrate_chart_date] = useState([])
    const rate_chart = useRef([])
    const rate_array = useRef([])
    const rate_per_array = useRef([])
    const [rate_tmp, setrate_tmp] = useState([])
    let fixedrate = null;
    let fixedprice = null;
    let digit = null;
    let splitter = null;
    let count = 0

    const search = useLocation().search;
    const query = search
        .slice(1)
        .split('&')
        .map((str) => [str.split('=')[0], str.split('=')[1]])
        .reduce((acc, a) => {
            acc[a[0]] = a[1];
            return acc;
        }, {} as QueryString);

    useEffect(() => {
        axios.get("https://account.swapnova.io/api/getratedetail?address=" + query["inputCurrency"])
            .then(res => {
                rate_array.current = res.data["rate"]
                rate_per_array.current = res.data["per"]
                setrate_chart_date(res.data["date"])
                setrate_min(res.data["min"])
                setrate_max(res.data["max"])
                rate_chart.current = res.data["price"]
            })
    }, [])

    useEffect(() => {
        const interval1 = setInterval(() => {
            setrate(rate_array.current?.[count])
            setrate_per(rate_per_array.current?.[count])
            setrate_tmp(rate_array.current?.[count - 1])
            let tmp = rate_chart.current.filter((price, index) => (index !== 13))
            rate_chart.current = [...tmp, rate_array.current?.[count]]

            count = count + 1
        }, 1000);
    }, [])

    useEffect(() => {
        const interval2 = setInterval(() => {
            axios.get("https://account.swapnova.io/api/getratedetail?address=" + query["inputCurrency"])
                .then(res => {
                    rate_array.current = res.data["rate"]
                    rate_per_array.current = res.data["per"]
                    setrate_chart_date(res.data["date"])
                    count = 0
                })
        }, 60000)
    }, [rate_array, rate_per_array, rate_chart])


    if (rate) {
        digit = 2
        splitter = Number(Number(rate).toString().substr(0, 7)).toString().split('.')

        if (splitter.length > 1) {
            digit = splitter[1].length > 2 ? splitter[1].length : 2
            fixedrate = Number(rate).toLocaleString(undefined, {minimumFractionDigits:digit,maximumFractionDigits: digit})

            fixedprice = Number(Number(balanceETH?.toSignificant(6)).toString().substr(0, 10)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
    }

    /** ##### **/

        // toggle wallet when disconnected
    const toggleWalletModal = useWalletModalToggle()

    // for expert mode
    const toggleSettings = useToggleSettingsMenu()
    const [isExpertMode] = useExpertModeManager()

    // get custom setting values for user
    const [allowedSlippage] = useUserSlippageTolerance()

    // swap state
    const {independentField, typedValue, recipient} = useSwapState()
    const {v2Trade, currencyBalances, parsedAmount, currencies, inputError: swapInputError} = useDerivedSwapInfo()
    const {wrapType, execute: onWrap, inputError: wrapInputError} = useWrapCallback(
        currencies[Field.INPUT],
        currencies[Field.OUTPUT],
        typedValue
    )

    const showWrap: boolean = wrapType !== WrapType.NOT_APPLICABLE
    const {address: recipientAddress} = useENSAddress(recipient)

    const trade = showWrap ? undefined : v2Trade

    const parsedAmounts = showWrap
        ? {
            [Field.INPUT]: parsedAmount,
            [Field.OUTPUT]: parsedAmount
        }
        : {
            [Field.INPUT]: independentField === Field.INPUT ? parsedAmount : trade?.inputAmount,
            [Field.OUTPUT]: independentField === Field.OUTPUT ? parsedAmount : trade?.outputAmount
        }

    const {onSwitchTokens, onCurrencySelection, onUserInput, onChangeRecipient} = useSwapActionHandlers()
    const isValid = !swapInputError
    const dependentField: Field = independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT

    const handleTypeInput = useCallback(
        (value: string) => {
            onUserInput(Field.INPUT, value)
        },
        [onUserInput]
    )
    const handleTypeOutput = useCallback(
        (value: string) => {
            onUserInput(Field.OUTPUT, value)
        },
        [onUserInput]
    )

    // modal and loading
    const [{showConfirm, tradeToConfirm, swapErrorMessage, attemptingTxn, txHash}, setSwapState] = useState<{
        showConfirm: boolean
        tradeToConfirm: Trade | undefined
        attemptingTxn: boolean
        swapErrorMessage: string | undefined
        txHash: string | undefined
    }>({
        showConfirm: false,
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    })

    const formattedAmounts = {
        [independentField]: typedValue,
        [dependentField]: showWrap
            ? parsedAmounts[independentField]?.toExact() ?? ''
            : parsedAmounts[dependentField]?.toSignificant(6) ?? ''
    }

    const route = trade?.route
    const userHasSpecifiedInputOutput = Boolean(
        currencies[Field.INPUT] &&
        currencies[Field.OUTPUT] &&
        parsedAmounts[independentField]?.greaterThan(JSBI.BigInt(0))
    )
    const noRoute = !route

    // check whether the user has approved the router on the input token
    const [approval, approveCallback] = useApproveCallbackFromTrade(trade, allowedSlippage)

    // check if user has gone through approval process, used to show two step buttons, reset on token change
    const [approvalSubmitted, setApprovalSubmitted] = useState<boolean>(false)

    // mark when a user has submitted an approval, reset onTokenSelection for input field
    useEffect(() => {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true)
        }
    }, [approval, approvalSubmitted])

    const maxAmountInput: CurrencyAmount | undefined = maxAmountSpend(currencyBalances[Field.INPUT])
    const atMaxAmountInput = Boolean(maxAmountInput && parsedAmounts[Field.INPUT]?.equalTo(maxAmountInput))

    // the callback to execute the swap
    const {callback: swapCallback, error: swapCallbackError} = useSwapCallback(trade, allowedSlippage, recipient)

    const {priceImpactWithoutFee} = computeTradePriceBreakdown(trade)

    const [singleHopOnly] = useUserSingleHopOnly()

    const handleSwap = useCallback(() => {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee)) {
            return
        }
        if (!swapCallback) {
            return
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm,
            showConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        })


        swapCallback()
            .then(hash => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: undefined,
                    txHash: hash
                })
                ReactGA.event({
                    category: 'Swap',
                    action:
                        recipient === null
                            ? 'Swap w/o Send'
                            : (recipientAddress ?? recipient) === account
                            ? 'Swap w/o Send + recipient'
                            : 'Swap w/ Send',
                    label: [
                        trade?.inputAmount?.currency?.getSymbol(chainId),
                        trade?.outputAmount?.currency?.getSymbol(chainId)
                    ].join('/')
                })

                ReactGA.event({
                    category: 'Routing',
                    action: singleHopOnly ? 'Swap with multihop disabled' : 'Swap with multihop enabled'
                })
            })
            .catch(error => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: error.message,
                    txHash: undefined
                })
            })
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        showConfirm,
        recipient,
        recipientAddress,
        account,
        trade,
        chainId,
        singleHopOnly
    ])

    // errors
    const [showInverted, setShowInverted] = useState<boolean>(false)

    // warnings on slippage
    const priceImpactSeverity = warningSeverity(priceImpactWithoutFee)

    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    const showApproveFlow =
        !swapInputError &&
        (approval === ApprovalState.NOT_APPROVED ||
            approval === ApprovalState.PENDING ||
            (approvalSubmitted && approval === ApprovalState.APPROVED)) &&
        !(priceImpactSeverity > 3 && !isExpertMode)

    const handleConfirmDismiss = useCallback(() => {
        setSwapState({showConfirm: false, tradeToConfirm, attemptingTxn, swapErrorMessage, txHash})
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(Field.INPUT, '')
        }
    }, [attemptingTxn, onUserInput, swapErrorMessage, tradeToConfirm, txHash])

    const handleAcceptChanges = useCallback(() => {
        setSwapState({tradeToConfirm: trade, swapErrorMessage, txHash, attemptingTxn, showConfirm})
    }, [attemptingTxn, showConfirm, swapErrorMessage, trade, txHash])

    const handleInputSelect = useCallback(
        inputCurrency => {
            setApprovalSubmitted(false) // reset 2 step UI for approvals
            onCurrencySelection(Field.INPUT, inputCurrency)
        },
        [onCurrencySelection]
    )

    const handleMaxInput = useCallback(() => {
        maxAmountInput && onUserInput(Field.INPUT, maxAmountInput.toExact())
    }, [maxAmountInput, onUserInput])

    const handleOutputSelect = useCallback(outputCurrency => onCurrencySelection(Field.OUTPUT, outputCurrency), [
        onCurrencySelection
    ])

    const swapIsUnsupported = useIsTransactionUnsupported(currencies?.INPUT, currencies?.OUTPUT)

    const [animateSwapArrows, setAnimateSwapArrows] = useState<boolean>(false)

    const options = {
        type: 'area',
        responsive: true,
        plugins: {
            title: {
                display: false,
                text: '',
            },
            tooltip: {
                enabled: true,
                displayColors:false,
            },
            legend: {
                display: false,
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        scales: {
            xAxis: {
                display: true,
                scaleLabel: {
                    display: false,
                    labelString: "Date"
                },
            },
            yAxis: {
                display: true,
                min: Number(rate_min) * 0.9,
                max: Number(rate_max) * 1.1,
            },
        }
    };

    const labels = rate_chart_date;

    const data = {
        labels,
        datasets: [
            {
                label: "Price",
                data: rate_chart.current,
                borderColor: "rgb(0, 188, 158)",
                backgroundColor: "rgba(0, 188, 158, 0.3)",
                fill: 'origin',
                pointStyle: "circle",
                pointRadius: 6,
            },
        ],
    };
    return (
        <>
            <Helmet>
                <title>Detail | NOVASWAP</title>
                <meta
                    name="description"
                    content="NOVASWAP allows for swapping of ERC20 compatible tokens across multiple networks"
                />
            </Helmet>
            <SwapPoolTabs active={'dashboard'}/>
            <div className="c-detail">
                <div className="c-detail__inner">
                    <div className="flex c-detail__content">
                        <div className="left">
                            <h3 className={loadedInputCurrency?.getName()}>{loadedInputCurrency?.getName()} Price ( {loadedInputCurrency?.getSymbol()} )</h3>
                            <div className="money">
                                {(() => {
                                    if (rate_tmp < rate) {
                                        return <span className="money_value green">$ {fixedrate}</span>
                                    }else if(rate_tmp > rate){
                                        return <span className="money_value red">$ {fixedrate}</span>
                                    }else{
                                        return <span className="money_value">$ {fixedrate}</span>
                                    }
                                })()}
                            <span
                                className={Number(rate_per) >= 0 ? "rate increase" : "rate decrease"}>{Number(rate_per) >= 0 ? "+" + rate_per : rate_per} % ( 24 hours )</span>
                            </div>
                            <Line options={options} data={data}/>
                        </div>
                        <div className="right">
                            <div className="right__top">
                                {account &&
                                <dl>
                                    <dt>Your Funds</dt>
                                    <dd>{fixedprice ?? "0.00"} <span>{loadedInputCurrency?.getSymbol()}</span></dd>
                                </dl>
                                }
                                <ul className="btn">
                                    <li><a className="buy" href={"/swap?outputCurrency=" + query["inputCurrency"]}>Buy</a></li>
                                    <li><a className="sell" href={"/swap?inputCurrency=" + query["inputCurrency"]}>Sell</a></li>
                                </ul>
                            </div>
                            {query["inputCurrency"] === "ETH" && (
                                <div className="right__bot">
                                <dl>
                                    <dt>Website</dt>
                                    <dd>
                                        <ul>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://ethereum.org/en/">ethereum.org</a></li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Explorer</dt>
                                    <dd>
                                        <ul>
                                            <li>
                                                <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/">Etherscan</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Wallet</dt>
                                    <dd>
                                        <ul>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://www.safepal.com/">SafePal</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://metamask.io/">Metamask</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://www.xdefi.io/">Xdefi</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://coin98.com/">Coin98</a></li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Community</dt>
                                    <dd>
                                        <ul>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://www.reddit.com/r/ethereum">Reddit</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/ethereum">Twitter</a></li>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/CetY6Y4">Discord</a></li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Media</dt>
                                    <dd>
                                        <ul>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$eth">Twitter</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl>
                                    <dt>Source</dt>
                                    <dd>
                                        <ul>
                                            <li><a target="_blank" rel="noreferrer noopener" href="https://github.com/ethereum">Github</a></li>
                                        </ul>
                                    </dd>
                                </dl>
                            </div>
                            )}
                            {query["inputCurrency"] === "0xdAC17F958D2ee523a2206206994597C13D831ec7" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xdac17f958d2ee523a2206206994597c13d831ec7">0xdAC17F...31ec7</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xdac17f958d2ee523a2206206994597c13d831ec7">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://trustwallet.com/">Trust Wallet</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x14eee29F4A62B8FB795D3AEc67543094ea1376df" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://begn-token.io/">begn-token.io</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x14eee29F4A62B8FB795D3AEc67543094ea1376df">0x960Bd...702FA</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x14eee29F4A62B8FB795D3AEc67543094ea1376df">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://metamsk.io">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647">0x1AdA2...b544b</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x07E19B50AFFfcc6FDE8585341332B47560328bB4" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x07E19B50AFFfcc6FDE8585341332B47560328bB4">0x3DEF4...a4d39</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x07E19B50AFFfcc6FDE8585341332B47560328bB4">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x96b2F3276C753169f2Db18954Eb59aEA46618e2b" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x96b2F3276C753169f2Db18954Eb59aEA46618e2b">0xcC4A0...f160cA</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x96b2F3276C753169f2Db18954Eb59aEA46618e2b">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x44cFCD80e45d4a708074F8a2791E9b6F41FeC600" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x44cfcd80e45d4a708074f8a2791e9b6f41fec600">0x44cFC...eC600</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x44cfcd80e45d4a708074f8a2791e9b6f41fec600">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0xCFcE2Ca008A5aE932110C0093e92528724cfAdd0" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xcfce2ca008a5ae932110c0093e92528724cfadd0">0xCFcE2...fAdd0</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xcfce2ca008a5ae932110c0093e92528724cfadd0">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://zaxs.us/">zaxs.us</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb">0x16980...22191</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Website</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/">tether.to</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://tether.to/en/transparency/">Whitepaper</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Metamask</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    {/*<dl>*/}
                                    {/*    <dt>Community</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Tether_to">Twitter</a></li>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/tether.to/">Facebook</a></li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                    {/*<dl>*/}
                                    {/*    <dt>Media</dt>*/}
                                    {/*    <dd>*/}
                                    {/*        <ul>*/}
                                    {/*            <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$usdt">Twitter</a>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </dd>*/}
                                    {/*</dl>*/}
                                </div>
                            )}
                            {query["inputCurrency"] === "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://ethereum.org/en/">0x2260F...2C599</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599">wbtc.network</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://wbtc.network/assets/wrapped-tokens-whitepaper.pdf">Whitepaper</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/WrappedBTC">Twitter</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$wbtc">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Source</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://github.com/WrappedBTC">Github</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84">0x3845b...3a5d0</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.sandbox.game/">sandbox.game</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://medium.com/sandbox-game">medium.com</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/TheSandboxGame">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://t.me/sandboxgame">Telegram</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/vAe4zvY">Discord</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$sand">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0">0x7D1Af...feBB0</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://polygon.technology/">polygon.technology</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://polygon.technology/lightpaper-polygon.pdf">Whitepaper</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://trezor.io/">Trezor</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.xdefi.io/">Xdefi</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://coin98.com/">Coin98</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://trustwallet.com/">Trust Wallet</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/0xPolygon">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://t.me/polygonofficial">Telegram</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/XvpHAxZ">Discord</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://t.me/PolygonAnnouncements">t.me</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$matic">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984">0x1f984...1F984</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://uniswap.org/">uniswap.org</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://uniswap.org/blog">uniswap.org</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.reddit.com/r/Uniswap">Raddit</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/Uniswap">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://snapshot.org/#/uniswap">Snapshot</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/FCfyBSbCU5">Discord</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$Uni">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2">0x9f8F7...579A2</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://makerdao.com/">makerdao.com</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://blog.makerdao.com/">blog.makerdao.com</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.reddit.com/r/MakerDAO">Raddit</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/MakerDAO">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/RBRumCpEDH">Discord</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$mkr">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x514910771AF9Ca656af840dff83E8264EcF986CA" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x514910771AF9Ca656af840dff83E8264EcF986CA">0xc944E...da44a7</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://thegraph.com/">thegraph.com</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://thegraph.com/blog/">thegraph.com</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/token/0x514910771AF9Ca656af840dff83E8264EcF986CA">Etherscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.reddit.com/r/thegraph">Raddit</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/graphprotocol">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://t.me/graphprotocol">Telegram</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://snapshot.org/#/graphprotocol.eth">Snapshot</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://discord.com/invite/vtvv7FP">Discord</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$grt">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Source</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://github.com/graphprotocol">Github</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                            {query["inputCurrency"] === "0x4E15361FD6b4BB609Fa63C81A2be19d873717870" && (
                                <div className="right__bot">
                                    <dl>
                                        <dt>Contract</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://etherscan.io/address/0x4e15361fd6b4bb609fa63c81a2be19d873717870">0x4E153...17870</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Website</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://fantom.foundation/">fantom.foundation</a></li>
                                            </ul>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://fantom.foundation/research/wp_fantom_v1.6.pdf">Whitepaper</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Explorer</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://ftmscan.com/">Ftmscan</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Wallet</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.ledger.com/">Ledger</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://trezor.io/">Trezor</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://coin98.com/">Coin98</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://trustwallet.com/">Trust Wallet</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.safepal.com/">SafePal</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Community</dt>
                                        <dd>
                                            <ul>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://www.reddit.com/r/FantomFoundation">Raddit</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://twitter.com/FantomFDN">Twitter</a></li>
                                                <li><a target="_blank" rel="noreferrer noopener" href="https://t.me/fantom_english">Telegram</a></li>
                                            </ul>
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Media</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/search?q=$ftm">Twitter</a>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
